import { api } from "@/api";

const localisationStore = {
  state: {
    localisations: []
  },
  getters: {
    getLocalisations(state) {
      return state.localisations;
    }
  },
  mutations: {
    setLocalisations(state, value) {
      state.localisations = value;
    },
    addLocalisation(state, value) {
      state.localisations.push(value);
    }
  },
  actions: {
    async loadLocalisations(context) {
      const res = await api.getLocalisations();
      context.commit("setLocalisations", res);
    },
    async addLocalisation(context, payload) {
      const res = await api.postLocalisation(payload);
      context.commit("addLocalisation", res);
      return res;
    }
  }
};

export default localisationStore;
